module.exports = __webpack_public_path__ + "img/L1070086.02beb657.jpg";